import React, { Component } from "react";

import { connect } from "react-redux";
import { withRouter } from "react-router";
import { withFirebase } from "../../firebase";

import Discount from "./index";

class PayCardContainer extends Component {
	constructor() {
		super();

		this.state = {
			preloader: false,
			saleFirstOrders: null,
			saleFirstOrder: null,
			promoCodes: null,
			keyShop: null,
			adminPermission: {},
			isSaleSystem: false,
		};
	}

	componentDidMount() {
		this.setState({
			keyShop: this.props.match.params.city,
		});
		this.checkLoyaltySettings();

		this.getFieldsSaleFirstOrder();
		this.getFieldSaleFirstOrder();
		this.getFieldsPromoCodes();
		this.getAdminPermission();
	}

	componentDidUpdate(prevProps, prevState) {
		let cityId = window.location.pathname.split("/");
		cityId = cityId[cityId.length - 1];

		if (this.state.keyShop !== cityId) {
			// console.log('prevProps, prevState', this.state.keyShop, cityId);
			this.setState({ keyShop: cityId });
			this.getFieldsSaleFirstOrder();
			this.checkLoyaltySettings();
		}
	}

	getAdminPermission = () => {
		const isDebug = JSON.parse(localStorage.getItem("isDebug"));

		this.props.firebase.bd
			.ref(`${isDebug ? "debug" : ""}/adminPermission`)
			.on("value", (snapshot) => {
				let adminPermission = snapshot.val();

				if (adminPermission) this.setState({ adminPermission });
			});
	};

	getFieldsSaleFirstOrder = () => {
		const currentCity = JSON.parse(localStorage.getItem("chosenCity"));
		const currentBrand = JSON.parse(localStorage.getItem("chosenBrand"));
		const isDebug = JSON.parse(localStorage.getItem("isDebug"));

		this.props.firebase.bd
			.ref(
				`${
					isDebug ? "debug" : ""
				}/settings/city/${currentCity}/brands/${currentBrand}/loyaltySettings/saleFirstOrder`
			)
			.on("value", (snapshot) => {
				let saleFirstOrders = snapshot.val();

				saleFirstOrders = saleFirstOrders ? saleFirstOrders : [];

				this.setState({ saleFirstOrders });
			});
	};

	checkLoyaltySettings = () => {
		// const { newAdmin } = this.state.adminPermission;
		// const currentCity = this.props.match.params.city;
		const isDebug = JSON.parse(localStorage.getItem("isDebug"));
		const currentCity = JSON.parse(localStorage.getItem("chosenCity"));
		const currentBrand = JSON.parse(localStorage.getItem("chosenBrand"));
		const adminPermission = JSON.parse(localStorage.getItem("adminPermission"));

		const refPath = adminPermission.newAdmin
			? `/settings/city/${currentCity}/brands/${currentBrand}/loyaltySettings/salesSystem`
			: `/settings/city/${currentCity}/loyaltySettings/salesSystem`;

		console.log(adminPermission.newAdmin);

		this.props.firebase.bd
			.ref(`${isDebug ? "debug" : ""}${refPath}`)
			.once("value", (snapshot) => {
				console.log("snapshot", snapshot);
				if (snapshot.exists()) {
					this.setState({ isSaleSystem: true });
				} else {
					this.setState({ isSaleSystem: false });
				}
			});
	};

	getFieldSaleFirstOrder = () => {
		const isDebug = JSON.parse(localStorage.getItem("isDebug"));
		this.props.firebase.bd
			.ref(`${isDebug ? "debug" : ""}/adminPermission/saleFirstOrder`)
			.on("value", (snapshot) => {
				let saleFirstOrder = snapshot.val();

				this.setState({ saleFirstOrder });
			});
	};

	getFieldsPromoCodes = () => {
		const isDebug = JSON.parse(localStorage.getItem("isDebug"));

		this.props.firebase.bd
			.ref(`${isDebug ? "debug" : ""}/adminPermission/promoCodes`)
			.on("value", (snapshot) => {
				let promoCodes = snapshot.val();

				this.setState({ promoCodes });
			});
	};

	changeChecker = (value) => {
		const currentCity = JSON.parse(localStorage.getItem("chosenCity"));
		const currentBrand = JSON.parse(localStorage.getItem("chosenBrand"));
		const isDebug = JSON.parse(localStorage.getItem("isDebug"));

		this.setState({ preloader: true });
		this.props.firebase.bd
			.ref(
				`${
					isDebug ? "debug" : ""
				}/settings/city/${currentCity}/brands/${currentBrand}/loyaltySettings/saleFirstOrder`
			)
			.update({ isAvailable: value })
			.then((res) => {
				this.setState({ preloader: false });
			});
	};

	sendData = (data) => {
		const currentCity = JSON.parse(localStorage.getItem("chosenCity"));
		const currentBrand = JSON.parse(localStorage.getItem("chosenBrand"));
		const isDebug = JSON.parse(localStorage.getItem("isDebug"));
		console.log("=== Submit data ===", data);

		let result = {
			isAvailable: true,
			discountId: "",
			id: "",
		};

		if (data) {
			result = { ...result, ...data };
		}

		console.log("result -->>>", result);

		this.setState({ preloader: true });
		this.props.firebase.bd
			.ref(
				`${
					isDebug ? "debug" : ""
				}/settings/city/${currentCity}/brands/${currentBrand}/loyaltySettings/saleFirstOrder`
			)
			.update(result)
			.then((res) => {
				this.setState({ preloader: false });
			});
		this.getFieldsSaleFirstOrder();
		this.props.getDefaultCity();
	};

	render() {
		// console.log('state, saleFirstOrder', this.state);
		return (
			<>
				<Discount
					isSaleSystem={this.state.isSaleSystem}
					onSubmitFirstOrder={this.sendData}
					adminPermission={this.state.adminPermission}
					loadStatus={this.state.preloader}
					keyShop={this.state.keyShop}
					saleFirstOrders={this.state.saleFirstOrders}
					saleFirstOrder={this.state.saleFirstOrder}
					promoCodes={this.state.promoCodes}
					changeChecker={this.changeChecker}
					handleCategoriesPromocode={this.props.handleCategoriesPromocode}
					handleProductsPromocode={this.props.handleProductsPromocode}
				/>
			</>
		);
	}
}

const mapStateToProps = (state) => {
	return {
		shops: state.shops.shops,
		appSettings: state.shops.appSettings,
	};
};

export default connect(
	mapStateToProps,
	null
)(withRouter(withFirebase(PayCardContainer)));
